import { RollbackOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

import { ReactComponent as CampusIcon } from './menu-items-icon/campus.svg'
import { ReactComponent as ClassIcon } from './menu-items-icon/class.svg'
import { ReactComponent as DashboardIcon } from './menu-items-icon/dashboard.svg'
import { ReactComponent as IncomeIcon } from './menu-items-icon/income.svg'
import { ReactComponent as MainIcon } from './menu-items-icon/main.svg'
import { ReactComponent as TeacherIcon } from './menu-items-icon/teacher.svg'

interface MenuItem {
  key: string
  label: any
  path?: string
  icon: JSX.Element
  children?: MenuItem[]
}

export const menuItems: MenuItem[] = [
  {
    key: '0',
    label: <Link to="/okulyonetimadmin">Dashboard</Link>,
    path: '/okulyonetimadmin',
    icon: <DashboardIcon className="icon material-icons" />,
  },
  {
    key: '1',
    label: <Link to="/okulyonetimadmin/ciro">Ciro</Link>,
    path: '/okulyonetimadmin/ciro',
    icon: <IncomeIcon className="icon material-icons" />,
  },
  {
    key: '2',
    label: <Link to="/okulyonetimadmin/okulsiparis">Okul Siparişleri</Link>,
    path: '/okulyonetimadmin/okulsiparis',
    icon: <MainIcon className="icon material-icons" />,
  },
  {
    key: '3',
    label: <Link to="/okulyonetimadmin/okulsiparissatiri">Okul Siparişleri Satırları</Link>,
    path: '/okulyonetimadmin/okulsiparissatiri',
    icon: <MainIcon className="icon material-icons" />,
  },
  {
    key: '4',
    label: <Link to="/okulyonetimadmin/okulsepeti">Okul Sepetleri</Link>,
    path: '/okulyonetimadmin/okulsepeti',
    icon: <MainIcon className="icon material-icons" />,
  },
  {
    key: '5',
    label: <Link to="/okulyonetimadmin/sube">Kampüsler</Link>,
    path: '/okulyonetimadmin/sube',
    icon: <CampusIcon className="icon material-icons" />,
  },
  {
    key: '6',
    label: <Link to="/okulyonetimadmin/subeyetkilisi">Kampüs Yetkileri</Link>,
    path: '/okulyonetimadmin/subeyetkilisi',
    icon: <CampusIcon className="icon material-icons" />,
  },
  {
    key: '7',
    label: <Link to="/okulyonetimadmin/sinifkategorisi">Sınıf Kategorileri</Link>,
    path: '/okulyonetimadmin/sinifkategorisi',
    icon: <ClassIcon className="icon material-icons" />,
  },
  {
    key: '8',
    label: <Link to="/okulyonetimadmin/sinif">Sınıflar</Link>,
    path: '/okulyonetimadmin/sinif',
    icon: <ClassIcon className="icon material-icons" />,
  },
  {
    key: '9',
    label: <Link to="/okulyonetimadmin/sinifdersi">Sınıf Dersleri</Link>,
    path: '/okulyonetimadmin/sinifdersi',
    icon: <ClassIcon className="icon material-icons" />,
  },
  {
    key: '10',
    label: <Link to="/okulyonetimadmin/dersurunu">Sınıf Listeleri</Link>,
    path: '/okulyonetimadmin/dersurunu',
    icon: <ClassIcon className="icon material-icons" />,
  },
  {
    key: '11',
    label: <Link to="/okulyonetimadmin/ogretmen">Öğretmenler</Link>,
    path: '/okulyonetimadmin/ogretmen',
    icon: <TeacherIcon className="icon material-icons" />,
  },
  {
    key: '12',
    label: <Link to="/">Satış Sitesine Git</Link>,
    path: '/',
    icon: <RollbackOutlined className="icon material-icons" />,
  },
]
